import * as React from 'react';


export interface ICustomTooolbarProps {
    view: string;
    views: string[];
    label: any;
    localizer: any;
    onNavigate: (action: any) => void;
    onView: (view: any) => void;
    onViewChange: (view: any) => void;
    messages: any;
    date: any;
}

export const navigateContants = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};

export const views = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};

const translate = {
    week: 'Tydzień',
    work_week: 'Tydzień P',
    day: 'Dzień',
    month: 'Miesiąc',
    previous: 'Poprzedni',
    next: 'Następny',
    today: `Dziś`,
    agenda: 'Agenda',
}
var setViewFunction:Function | null = null;

export function setView(view:string){
    if(setViewFunction !== null){
        //setViewFunction(view);
    }
}


const CustomToolbar: React.FC<ICustomTooolbarProps> = (props) => {
    const [selectView, setSelectView] = React.useState(props.view);
    setViewFunction = props.onView;

    if(selectView !== props.view){
        //setSelectView(props.view);
    }
    
    function navigate(action: any) {
        //props.onNavigate(action);
    }

    function viewItem(view: any) {
        //props.onView(view);
    }

    function viewNamesGroup(messages: any) {
        const viewNames = props.views;
        const view = props.view;

        if (viewNames.length > 1) {
            // return (<select >
            //     <option value="Ford">Ford</option>
            //     <option value="Volvo">Volvo</option>
            //     <option value="Fiat">Fiat</option>
            //   </select>

            // return viewNames.map((name) => (
            //     <button
            //         type="button"
            //         key={name}
            //         //className={css({ 'rbc-active': view === name })}
            //         onClick={viewItem.bind(null, name)}
            //         >
            //         {
            //             //@ts-ignore
            //         translate[name]}
            //     </button>

            return (<select style={{
                color: '#373a3c',
                display: 'inline-block',
                margin: '0',
                textAlign: 'center',
                verticalAlign: 'middle',
                background: 'none',
                backgroundImage: 'none',
                border: '1px solid #ccc',
                padding: '0.375rem 1rem',
                borderRadius: '4px',
                lineHeight: 'normal',
                whiteSpace: 'nowrap'
              }} 
              value={selectView} onChange={(e) => {
                if (selectView !== e.target.value) {
                    viewItem(e.target.value)
                }
            }
            }>
                {viewNames.map((name) => (
                    <option
                        value={name}
                        key={name}
                    >
                        {
                            //@ts-ignore
                            translate[name]}
                    </option>
                ))}
            </select>);
        }
    }


    return (
        <div className="rbc-toolbar">
            {/* <span className="rbc-btn-group">
                <button type="button" onClick={navigate.bind(null, navigateContants.TODAY)}>
                    dziś
                </button>
            </span> */}
            {/* <span className="rbc-btn-group">

                <button type="button" onClick={navigate.bind(null, navigateContants.PREVIOUS)}>
                    &lt;
                </button>
                <span className="rbc-toolbar-label">{props.localizer.format(props.date, props.view=='day'?"DD.MM.yyyy":"MM.yyyy")}</span>
                <button type="button" onClick={navigate.bind(null, navigateContants.NEXT)}>
                    &gt;
                </button>

            </span> */}
            {/* <span className="rbc-btn-group">{viewNamesGroup(props.views)}</span> */}



        </div>
    );
};

export default CustomToolbar;